const HighlightsStarIcon = ({ pathFill = '#ECF3AB' }: { pathFill?: string }) => (
  <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.1452 7.36239C6.57272 7.59909 6.82706 7.42694 6.7145 6.98268L6.19106 4.91671L7.9375 3.52734C8.31487 3.22713 8.21511 2.95181 7.72004 2.91282L5.41782 2.73147L4.5185 0.78365C4.32418 0.362774 4.00819 0.364794 3.81481 0.78365L2.91549 2.73147L0.613266 2.91282C0.115809 2.952 0.0202562 3.22857 0.395809 3.52734L2.14227 4.91671L1.61881 6.98268C1.50571 7.42909 1.76264 7.59795 2.18811 7.36239L4.16667 6.26695L6.1452 7.36239Z"
      fill={pathFill}
    />
  </svg>
);

export default HighlightsStarIcon;
